import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface ICurrencyAmount {
    amount: number;
    currency: string;
    symbol: string;
}

interface IConfirmation {
    events: Array<Object>;
    url: string;
    deliveryMethodName: string;
    confirmationNumber: string;
    roktPayload: object;
    gst: string;
    abn: string;
    hideTaxInvoice: boolean;
    receiptLocale: string;
    paymentNote: string;
    amountPaid: ICurrencyAmount | null;
}

interface IConfirmationState {
    events: Array<Object>;
    receiptUrl: string;
    ticketsUrl: string;
    deliveryMethodName: string;
    confirmationNumber: string;
    roktPayload: object;
    gst: string;
    abn: string;
    hideTaxInvoice: boolean;
    receiptLocale: string;
    paymentNote: string;
    amountPaid: ICurrencyAmount | null;
}

const initialState: IConfirmationState = {
    events: [],
    receiptUrl: "",
    ticketsUrl: "",
    deliveryMethodName: "",
    confirmationNumber: "",
    roktPayload: {},
    gst: 0,
    abn: '',
    hideTaxInvoice: true,
    receiptLocale: 'en_US',
    paymentNote: '',
    amountPaid: null,
};

export const confirmationSlice = createSlice({
    name: 'confirmation',
    initialState,
    reducers: {
        setConfirmationEvents: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.events = payload.events;
            return newState;
        },

        setReceiptUrl: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.receiptUrl = payload.url;
            return newState;
        },

        setTicketsUrl: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.ticketsUrl = payload.url;
            return newState;
        },

        setDeliveryMethodName : (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.deliveryMethodName = payload.deliveryMethodName;
            return newState;
        },

        setConfirmationNumber: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.confirmationNumber = payload.confirmationNumber;
            return newState;
        },
        setRoktPayload: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.roktPayload = payload.roktPayload;
            return newState;
        },
        setGSTData: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.gst = payload.gst;
            newState.abn = payload.abn;
            newState.hideTaxInvoice = payload.hideTaxInvoice;
            newState.receiptLocale = payload.receiptLocale;
            newState.paymentNote = payload.paymentNote;
            newState.amountPaid = payload.amountPaid ?? null;
            return newState;
        },
    },

    extraReducers: (builder) => {
        builder.addDefaultCase((state, action) => {
            return state;
        })
    }
});
